import React, { useState, useEffect } from "react";

const App = () => {
  const [activeComponent, setActiveComponent] = useState(() => {
    return localStorage.getItem("activeComponent") || "home";
  });
  const [leftSidebarOption, setLeftSidebarOption] = useState(() => {
    return localStorage.getItem("leftSidebarOption") || null;
  });
  const [dateAndTime, setDateAndTime] = useState(() => {
    return localStorage.getItem("dateAndTime") || "";
  });
  const [foodEaten, setFoodEaten] = useState(() => {
    return localStorage.getItem("foodEaten") || "";
  });
  const [todaysWeight, setTodaysWeight] = useState(() => {
    return localStorage.getItem("todaysWeight") || "";
  });
  const [dietEntries, setDietEntries] = useState(() => {
    const savedEntries = localStorage.getItem("dietEntries");
    return savedEntries ? JSON.parse(savedEntries) : [];
  });

  useEffect(() => {
    localStorage.setItem("activeComponent", activeComponent);
  }, [activeComponent]);

  useEffect(() => {
    localStorage.setItem("leftSidebarOption", leftSidebarOption);
  }, [leftSidebarOption]);

  useEffect(() => {
    localStorage.setItem("dateAndTime", dateAndTime);
  }, [dateAndTime]);

  useEffect(() => {
    localStorage.setItem("foodEaten", foodEaten);
  }, [foodEaten]);

  useEffect(() => {
    localStorage.setItem("todaysWeight", todaysWeight);
  }, [todaysWeight]);

  useEffect(() => {
    localStorage.setItem("dietEntries", JSON.stringify(dietEntries));
  }, [dietEntries]);

  const renderContent = () => {
    if (activeComponent === "dailydiet") {
      return (
        <div style={styles.contentArea}>
          <h2>Daily Diet Form</h2>
          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.formGroup}>
              <label>Date and Time:</label>
              <input
                type="datetime-local"
                value={dateAndTime}
                onChange={(e) => setDateAndTime(e.target.value)}
                required
                style={styles.input}
              />
            </div>
            <div style={styles.formGroup}>
              <label>Food Eaten:</label>
              <input
                type="text"
                value={foodEaten}
                onChange={(e) => setFoodEaten(e.target.value)}
                required
                style={styles.input}
              />
            </div>
            <div style={styles.formGroup}>
              <label>Today's Weight (kg):</label>
              <input
                type="number"
                step="0.1"
                value={todaysWeight}
                onChange={(e) => setTodaysWeight(e.target.value)}
                required
                style={styles.input}
              />
            </div>
            <button type="submit" style={styles.button}>
              Add
            </button>
          </form>
          <h3>All Entries</h3>
          {dietEntries.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.tableHeader}>Date and Time</th>
                    <th style={styles.tableHeader}>Food Eaten</th>
                    <th style={styles.tableHeader}>Today's Weight</th>
                    <th style={styles.tableHeader}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dietEntries.map((entry, index) => (
                    <tr key={index}>
                      <td style={styles.tableCell}>{entry.dateAndTime}</td>
                      <td style={styles.tableCell}>{entry.foodEaten}</td>
                      <td style={styles.tableCell}>{entry.todaysWeight} kg</td>
                      <td style={styles.tableCell}>
                        <button
                          style={styles.button}
                          onClick={() => handleEdit(index)}
                        >
                          Edit
                        </button>
                        <button
                          style={{ ...styles.button, backgroundColor: "red" }}
                          onClick={() => handleDelete(index)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No entries found. Add some diet records!</p>
          )}
        </div>
      );
    } else if (leftSidebarOption) {
      return (
        <div style={styles.contentArea}>
          <h2>{leftSidebarOption}</h2>
          <p>
            {leftSidebarOption === "Option 1"
              ? "This is some text data for Option 1."
              : "This is some text data for Option 2."}
          </p>
        </div>
      );
    }
    return <h2 style={styles.contentArea}>Welcome to My Application</h2>;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newEntry = { dateAndTime, foodEaten, todaysWeight };
    setDietEntries((prevEntries) => [...prevEntries, newEntry]);
    setDateAndTime("");
    setFoodEaten("");
    setTodaysWeight("");
  };

  const handleEdit = (index) => {
    setDateAndTime(dietEntries[index].dateAndTime);
    setFoodEaten(dietEntries[index].foodEaten);
    setTodaysWeight(dietEntries[index].todaysWeight);
    setDietEntries(dietEntries.filter((_, i) => i !== index));
  };

  const handleDelete = (index) => {
    setDietEntries(dietEntries.filter((_, i) => i !== index));
  };

  return (
    <div style={styles.appContainer}>
      <style>{`
        body {
          margin: 0;
          font-family: Arial, sans-serif;
        }
       
      `}</style>
      <nav style={styles.navbar}>
        <h1 style={{ margin: 0 }}>My Application</h1>
        <ul style={styles.navLinks}>
          <li style={styles.navItem} onClick={() => setActiveComponent("dailydiet")}>
            Daily Diet Form
          </li>
        </ul>
      </nav>
      <div style={styles.mainContent}>
        <aside style={styles.leftSidebar}>
          <ul style={styles.sidebarLinks}>
            <li
              style={styles.sidebarItem}
              onClick={() => {
                setActiveComponent("sidebar");
                setLeftSidebarOption("Option 1");
              }}
            >
              Option 1
            </li>
            <li
              style={styles.sidebarItem}
              onClick={() => {
                setActiveComponent("sidebar");
                setLeftSidebarOption("Option 2");
              }}
            >
              Option 2
            </li>
          </ul>
        </aside>
        <div style={styles.contentArea}>{renderContent()}</div>
      </div>
      <footer style={styles.bottomBar}>
        <p>&copy; 2024 My Application</p>
      </footer>
    </div>
  );
};

const styles = {
  appContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  navbar: {
    backgroundColor: "#007bff",
    color: "white",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  navLinks: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
  },
  navItem: {
    marginLeft: "20px",
    cursor: "pointer",
    color: "white",
  },
  mainContent: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
  },
  leftSidebar: {
    width: "20px",
    backgroundColor: "#f4f4f4",
    padding: "10px",
  },
  sidebarLinks: {
    listStyle: "none",
    padding: 0,
  },
  sidebarItem: {
    margin: "10px 0",
    cursor: "pointer",
  },
  contentArea: {
    flex: 1,
    padding: "20px",
    overflowY: "auto",
  },
  bottomBar: {
    backgroundColor: "#007bff",
    color: "white",
    textAlign: "center",
    padding: "10px",
  },
  form: {
    marginBottom: "20px",
  },
  formGroup: {
    marginBottom: "10px",
  },
  input: {
    width: "100%",
    padding: "8px",
    marginBottom: "10px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    cursor: "pointer",
    marginRight: "10px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
    border: "1px solid #ddd",
  },
  tableHeader: {
    backgroundColor: "#007bff",
    color: "white",
    padding: "10px",
    textAlign: "left",
    border: "1px solid #ddd",
  },
  tableCell: {
    padding: "10px",
    border: "1px solid #ddd",
  },
  "@media (max-width: 480px)": {
    leftSidebar: {
      width: "50%",
      display: "none", // Optionally hide sidebar on very small screens
    },
    navbar: {
      alignItems: "center",
    },
    contentArea: {
      padding: "5px",
    },
  },
};

export default App;
